import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiNavigation, FiGlobe, FiMap, FiShield, FiArrowRight, FiBox, FiFileText } = FiIcons;

const Services = () => {
  // Data layanan disesuaikan dengan layanan logistik standar
  const services = [
    {
      id: 'air-freight',
      icon: FiNavigation,
      title: 'Air Freight',
      desc: 'Layanan kargo udara komprehensif untuk pengiriman yang cepat ke berbagai tujuan domestik dan internasional.',
      image: '/air-freight.png'
    },
    {
      id: 'sea-freight',
      icon: FiGlobe,
      title: 'Sea Freight',
      desc: 'Solusi pengiriman laut global, menyangkut rute logistik lintas benua untuk kargo skala besar yang efisien.',
      image: '/sea-freight.png'
    },
    {
      id: 'door-to-door',
      icon: FiMap,
      title: 'Door to Door Delivery',
      desc: 'Layanan penjemputan dari lokasi asal hingga pengiriman langsung ke tangan penerima tanpa kerumitan.',
      image: '/door-to-door.png'
    },
    {
      id: 'customs',
      icon: FiShield,
      title: 'Customs Clearance',
      desc: 'Penanganan bea cukai yang sesuai standar untuk kelancaran distribusi keluar/masuk pelabuhan.',
      image: '/customs.png'
    },
    {
      id: 'export-import',
      icon: FiGlobe,
      title: 'Export Import Handling',
      desc: 'Dukungan penuh untuk menangani aktivitas ekspor dan impor Anda dengan kepatuhan hukum.',
      image: '/export-import.png'
    },
    {
      id: 'packaging',
      icon: FiBox,
      title: 'Packaging & Documentation Support',
      desc: 'Layanan pengepakan aman dan penyusunan semua dokumen pengiriman untuk barang-barang Anda.',
      image: '/packaging.png'
    }
  ];

  return (
    <div className="pt-24 min-h-screen bg-metallic-light pb-20">
      <div className="max-w-[1200px] mx-auto px-6">
        
        <div className="text-center mb-16 pt-8">
          <h1 className="text-4xl md:text-5xl font-bold text-navy mb-4">Layanan Utama Kami</h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Solusi komprehensif yang dirancang untuk menjawab tantangan pengiriman Anda dengan presisi, keamanan, dan fleksibilitas tanpa batas.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-12">
          {services.map((srv, index) => (
            <motion.div 
              key={srv.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              className={`flex flex-col ${index % 2 !== 0 ? 'md:flex-row-reverse' : 'md:flex-row'} bg-white rounded-3xl overflow-hidden shadow-xl border border-slate-100 md:h-[400px]`}
            >
              <div className="md:w-1/2 h-64 md:h-full relative shrink-0">
                <img src={srv.image} alt={srv.title} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-navy/80 to-transparent md:hidden"></div>
              </div>
              <div className="md:w-1/2 p-8 md:p-12 flex flex-col justify-center grow">
                <div className="w-12 h-12 bg-orange/10 rounded-xl flex items-center justify-center text-orange mb-6">
                  <SafeIcon icon={srv.icon} className="text-2xl" />
                </div>
                <h2 className="text-3xl font-bold text-navy mb-4">{srv.title}</h2>
                <p className="text-slate-600 text-lg leading-relaxed mb-8">{srv.desc}</p>
                <button className="self-start text-orange font-semibold flex items-center gap-2 hover:text-navy transition-colors group">
                  Pelajari Lebih Lanjut <SafeIcon icon={FiArrowRight} className="transform group-hover:translate-x-1 transition-transform" />
                </button>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default Services;